import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithTimer(props) {
  const totalSeconds = Math.round(props?.value / props?.secondsToLoad);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds} sec`;
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" size="10rem" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.secondary' }}
        >
          {props?.showTimeInMin ? formattedTime : `${totalSeconds} sec`}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithTimer;